import { useCmsPage } from "@/hooks/useCms";
import LoadingScreen from "@/components/LoadingScreen";
import PageRenderer from "@/components/cms/PageRenderer";

/**
 * Generic public CMS page — renders anything the admin builds.
 * Falls back to the current title if no sections exist.
 */
export default function StaticCmsPage({ slug }) {
  const { page, loading } = useCmsPage(slug);
  if (loading) return <LoadingScreen />;
  if (!page) return null;

  const hasContent = (page.sections || []).some((s) => (s.blocks || []).length > 0);
  if (!hasContent) {
    return (
      <section className="sqit-section">
        <div className="sqit-container max-w-3xl">
          <div className="text-xs font-semibold uppercase tracking-widest text-[#538135]">SQIT.AI</div>
          <h1 className="mt-3 font-display text-4xl sm:text-5xl font-bold text-gray-900 tracking-tight">{page.title}</h1>
          <p className="mt-6 text-gray-500">This page has no content yet.</p>
        </div>
      </section>
    );
  }
  return <PageRenderer page={page} />;
}
